<!------------------------------------------------------------------------------
 File: BaseTabIn 
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 23/10/2018
 Time: 12:56
------------------------------------------------------------------------------->
<template>
    <div class="mx-2"
    >&nbsp;</div>
</template>

<script>
    export default {
        name: '',
        components: {},
        props: {
            side_border:{
                default:true
            }
        },
        created() {},
        destroyed() {},
        mounted() {

        },
        data() {
            return {};
        },
        methods: {},
        watch: {},
        computed: {}
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/base/BaseTabIn.vue?0c510c00